export default __webpack_public_path__ + "static/media/brandIcon.33803d7c.png";